module.exports = __webpack_public_path__ + "img/rectangle-terminal.4e104082.svg";